"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portugalTranslations = void 0;
var _types = require("../../../types");
const portugalTranslations = exports.portugalTranslations = {
  [_types.ErrorPageTranslationKey.headline]: ' Pedimos desculpa!',
  [_types.ErrorPageTranslationKey.buttonText]: ' Recuar',
  [_types.ErrorPageTranslationKey.text]: ' Neste momento, esta página não está disponível',
  [_types.ErrorPageTranslationKey.notFound]: 'A página que está a tentar abrir não está a funcionar',
  [_types.ErrorPageTranslationKey.unauthorized]: 'A página que está a tentar abrir é restrita e não tem acesso.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Por favor, contacte a equipa de apoio da Oriflame por e-mail:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'O URL solicitado foi rejeitado!'
};
